import {PropsWithChildren} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {ComponentFallback} from '../ComponentFallback/ComponentFallback';

export function ComponentErrorBoundary({children}: PropsWithChildren<{}>) {
  return (
  // @ts-ignore - A bug in this library
    <ErrorBoundary FallbackComponent={ComponentFallback}>
      {children}
    </ErrorBoundary>
  );
}
